/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {interpolateTemplate} from '../../common/filters/interpolate-template';

const DESCRIPTION_MAX_LENGTH = 100;
const SAVE_ERROR_FALLBACK = 'The targeting template could not be saved. Please try again.';

export function truncateTargetingTemplateDescription(description: any): any {
  if (!_.isString(description) || description.length <= DESCRIPTION_MAX_LENGTH) {
    return description;
  }
  return description.substring(0, DESCRIPTION_MAX_LENGTH) + '...';
}

export function targetingTemplateSaveErrors(response: any): string[] {
  let errors = _.get(response, ['data', 'errors']);
  if (_.isNil(errors)) {
    const responseData = _.get(response, 'data');
    if (_.isString(responseData)
      || _.isArray(responseData)
      || _.get(responseData, 'error')
      || _.get(responseData, 'code')
      || _.get(responseData, 'text')
      || _.get(responseData, 'message')) {
      errors = responseData;
    }
  }

  const messages = _.compact(_.map(_.isArray(errors) ? errors : (_.isNil(errors) ? [] : [errors]), (error: any) => {
    const errorInfo = _.get(error, 'error') || error;
    if (_.isString(errorInfo)) {
      return errorInfo;
    }
    const text = _.get(errorInfo, 'text') || _.get(errorInfo, 'message') || _.get(errorInfo, 'code');
    return text ? interpolateTemplate(text)(_.get(errorInfo, 'parameters')) : null;
  }));

  return messages.length ? messages : [SAVE_ERROR_FALLBACK];
}
